/**
 * 반응형 레이아웃 상태를 관리하는 Custom Hook
 * Single Responsibility: 화면 크기별 반응형 상태만 담당
 */ import { useState, useEffect } from 'react';
const parseBreakpoint = (value, fallback)=>{
    const parsed = parseInt((value ?? '').replace('px', ''), 10);
    return Number.isFinite(parsed) ? parsed : fallback;
};
const createResponsiveState = (breakpoints)=>{
    const width = typeof window !== 'undefined' ? window.innerWidth : 1024;
    const mdBreakpoint = parseBreakpoint(breakpoints.md, 768);
    const lgBreakpoint = parseBreakpoint(breakpoints.lg, 1024);
    return {
        isMobileView: width < mdBreakpoint,
        isTabletView: width >= mdBreakpoint && width < lgBreakpoint,
        isDesktopView: width >= lgBreakpoint,
        screenWidth: width
    };
};
export const useResponsiveLayout = (breakpoints = {})=>{
    const defaultBreakpoints = {
        xs: '480px',
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px',
        '2xl': '1536px',
        ...breakpoints
    };
    const [responsiveState, setResponsiveState] = useState(()=>createResponsiveState(defaultBreakpoints));
    useEffect(()=>{
        const updateResponsiveState = ()=>{
            setResponsiveState(createResponsiveState(defaultBreakpoints));
        };
        updateResponsiveState();
        window.addEventListener('resize', updateResponsiveState);
        return ()=>window.removeEventListener('resize', updateResponsiveState);
    }, [
        defaultBreakpoints.md,
        defaultBreakpoints.lg
    ]);
    return responsiveState;
};
